import Vue from 'vue'

// 创建EventBus实例
const EventBus = new Vue()

export default EventBus


